import { Form, Button, Row, Col } from 'react-bootstrap';

const BrutalistForm = () => {
  return (
    <div className="form-container-brutalist p-4 pt-0">
      <Form>
        <Row>
          {/* Nombre */}
          <Col md={6} className="mb-4">
            <Form.Group>
              <Form.Label className="label-brutalist">Tu Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="EJ. SOFIA GARCÍA"
                className="input-brutalist"
              />
            </Form.Group>
          </Col>

          {/* Nombre del Restaurante */}
          <Col md={6} className="mb-4">
            <Form.Group>
              <Form.Label className="label-brutalist">Nombre del Restaurante</Form.Label>
              <Form.Control
                type="text"
                size='sm'
                placeholder="EJ. EUREKA BISTRO"
                className="input-brutalist"
              />
            </Form.Group>
          </Col>

          {/* Correo */}
          <Col md={6} className="mb-4">
            <Form.Group>
              <Form.Label className="label-brutalist">Email</Form.Label>
              <Form.Control
                type="email"
                size='sm'
                placeholder="HOLA@RESTAURANTE.COM"
                className="input-brutalist"
              />
            </Form.Group>
          </Col>

          {/* Teléfono */}
          <Col md={6} className="mb-4">
            <Form.Group>
              <Form.Label className="label-brutalist">Teléfono</Form.Label>
              <Form.Control
                type="tel"
                size='sm'
                placeholder="55 1234 5678"
                className="input-brutalist"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Botón de Enviar Estilo Sticker */}
        <div className="text-center mt-3">
          <Button className="btn-submit-brutalist w-100">
            ¡REGISTRAR MI MARCA!
          </Button>
          <p className="mt-5 small text-uppercase opacity-50" style={{ letterSpacing: '2px', fontSize: '11px' }}>
            * Al registrarte aceptas que nos pondremos en contacto para la dinámica.
          </p>
        </div>
      </Form>
    </div>
  );
};

export default BrutalistForm;